import http from "../http-common";

// Look up a booking receipt by booking number + email ("Mina bokningar").
const lookup = (bookingNo, email) => {
    return http.post("/booking/lookup", {
        booking_no: bookingNo,
        email,
    }).then(response => response.data);
};

const BookingLookupService = {
    lookup,
};

export default BookingLookupService;
